<div class="page-section">
  <div class="section-content">
    <div class="brand">
      <a href="/"><img src="assets/images/small-logo.png" /></a>
    </div>

    <div class="links">
      <a class="link" href="/#about"> About </a>
      <a class="link" href="/#ai-tooling"> AI Tooling </a>
      <a class="link" href="/#services"> Services </a>
    </div>

    <div class="actions">
      <a class="primary-rounded-btn" [href]="customerAppURLBase + '/register'">
        Sign Up</a
      >
      <a
        class="primary-rounded-btn"
        id="login-btn"
        [href]="customerAppURLBase + '/login'">
        Login</a
      >
    </div>
  </div>
</div>
